import { createSelector } from 'reselect';
import { getConfirmedRunningStart } from './getConfirmedRunningStart';
import { getStagedPicksByWoo, getStagedBaselineByWoo } from './getPicking';

/**
 * The staged job-start picks that are ready to be written, as
 * { workOrderOperationRef, picks }, or null.
 *
 * Picks are ready once the server confirms a start of their WOO, or a change of its
 * activity, other than the one already running when they were staged. Without that
 * check, picking a WOO that is already running would write the picks the moment
 * they are staged, before the operator chooses an activity.
 */
const getStagedPicksToWrite = createSelector(
  [getConfirmedRunningStart, getStagedPicksByWoo, getStagedBaselineByWoo],
  (start, stagedByWoo, baselineByWoo) => {
    if (!start) return null;

    const key = String(start.workOrderOperationRef);
    const picks = stagedByWoo[key];
    if (!picks?.length) return null;

    const baseline = baselineByWoo[key];
    if (baseline != null && String(baseline) === String(start.startRef)) {
      return null;
    }

    return { workOrderOperationRef: start.workOrderOperationRef, picks };
  }
);

export { getStagedPicksToWrite };
